import { Component, input, output, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  standalone: true,
  selector: 'base-button-sm',
  templateUrl: './button-sm.component.html',
  styleUrls: ['./button-sm.component.scss'],
  imports: [CommonModule, SpinnerComponent]
})
export class ButtonSmComponent {

  readonly isSecondaryBtnStyle = input<boolean>(false);
  readonly loading = input<boolean>(false);
  readonly disabled = input<boolean>(false);

  readonly isButtonDisabled = computed(() => this.loading() || this.disabled());
  readonly showSpinner = computed(() => this.loading());

  // Update output to use Angular 20 output() function
  buttonClicked = output<boolean>();

  onButtonClick() {
    if (!this.isButtonDisabled()) {
      this.buttonClicked.emit(true);
    }
  }
}

